"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgWarningTriangle = function SvgWarningTriangle(_ref) {
  var fill = _ref.fill,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["fill", "theme"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "12",
    height: "11",
    viewBox: "0 0 12 11",
    fill: "none"
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      d: "M5.5 6.5V4.5H6.5V6.5H5.5Z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M6.5 8C6.5 8.27614 6.27614 8.5 6 8.5C5.72386 8.5 5.5 8.27614 5.5 8C5.5 7.72386 5.72386 7.5 6 7.5C6.27614 7.5 6.5 7.72386 6.5 8Z",
      fill: fill || theme.colors.primary.main
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.43708 0.757179C6.34889 0.598446 6.18158 0.5 6 0.5C5.81842 0.5 5.65111 0.598446 5.56292 0.757179L0.562921 9.75718C0.476885 9.91204 0.479222 10.1009 0.569065 10.2536C0.658907 10.4063 0.82284 10.5 1 10.5H11C11.1772 10.5 11.3411 10.4063 11.4309 10.2536C11.5208 10.1009 11.5231 9.91204 11.4371 9.75718L6.43708 0.757179ZM1.84976 9.5L6 2.02956L10.1502 9.5H1.84976Z",
      fill: fill || theme.colors.primary.main
    })]
  }));
};

var _default = SvgWarningTriangle;
exports["default"] = _default;